export type NotificationCategory = 'activity' | 'todo';

export const TODO_NOTIFICATION_TYPES = new Set([
    'needs_attention_auto_refresh_portfolio',
    'needs_attention_auto_refresh_custom_security',
    'integration_health_check_failed',
    'unmapped_holdings_auto_refresh_portfolio',
    'bob_sync_needs_attention',
    'quick_extract_complete',
    'unmapped_risk_profile_labels',
    'rtq_submission_received',
    'auto_share_failed',
]);
